import {Component, effect, inject, input, output, signal, untracked} from '@angular/core';
import {form, FormField, required} from '@angular/forms/signals';
import {isEqual} from 'lodash';
import {SharedModule} from '../../modules/shared.module';
import {CertificateTemplateItem, CertificateTemplateService} from '../../services/certificateTemplate.service';

export interface CertificateSetting {
  certificateAllowed: boolean;
  certificateTemplateId?: number | null;
}

const initialData: CertificateSetting = {
  certificateAllowed: false,
  certificateTemplateId: null
};

@Component({
  selector: 'certificate-setting',
  templateUrl: './certificate-setting.component.html',
  styleUrls: ['./certificate-setting.component.scss'],
  standalone: true,
  imports: [SharedModule, FormField]
})
export class CertificateSettingComponent {
  private certificateTemplateService = inject(CertificateTemplateService);

  certificateModel = signal<CertificateSetting>(initialData);
  certificateForm = form(this.certificateModel, certificate => {
    required(certificate.certificateTemplateId, {
      when: ({valueOf}) => valueOf(certificate.certificateAllowed),
      message: 'event.is_required_field'
    });
  });
  certificateData = input<CertificateSetting>();
  organizationId = input<number | null>(null);
  certificateFormResult = output<CertificateSetting>();
  certificateTemplates = signal<CertificateTemplateItem[]>([]);

  constructor() {
    effect(() => {
      const newData = this.certificateData();
      if (newData) {
        const currentModel = untracked(() => this.certificateModel());
        if (!isEqual(currentModel, newData)) {
          untracked(() => {
            this.certificateModel.set({...newData});
          });
        }
      }
    });

    effect(() => {
      const result = this.certificateModel();
      untracked(() => {
        if (!isEqual(result, this.certificateData())) {
          this.certificateFormResult.emit(result);
        }
      });
    });

    effect((onCleanup) => {
      const organizationId = this.organizationId();
      const certificateEnabled = this.certificateTemplateService.certificateEnabled();
      this.certificateTemplates.set([]);

      if (certificateEnabled && organizationId) {
        const subscription = this.certificateTemplateService.templates(organizationId).subscribe(templates => {
          this.certificateTemplates.set(templates);
        });
        onCleanup(() => subscription.unsubscribe());
      }
    });
  }
}
